import {QuickAddItemType} from "../../../app/quick-add/@types";


export function isGDSystemLink(url:string):boolean {

    // // it allows internal GD links i.e. gd://request-form/xxxx
    // const gdUrlRegex = /^gd:\/\/[a-zA-Z0-9\/]+$/;
    // gdUrlRegex.test(value)


    return url?.substring(0,5) === 'gd://'
}


export function openGDSystemLink(url:string):void {

    const path = url.substring(5)

    const pathArray = path.split('/')

    switch (pathArray[0]) {

        case 'request-form':

            const requestFormId = pathArray[1]
            if (requestFormId) {
                gd.openNew(QuickAddItemType.REQUEST, {id: requestFormId})
            }

            break
    }


}